import React, { useState } from 'react';
import axios from 'axios';

const UploadWordDocument = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', '1'); // Replace with actual user ID
    formData.append('topic', 'Sample Topic');
    formData.append('summary', 'Sample Summary');
    formData.append('location', 'Sample Location');
    formData.append('platform', 'Sample Platform');
    formData.append('valueChain', 'Sample value chain');
    formData.append('targetUser', 'Sample target user');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/upload-word`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      setMessage(response.data.msg);
    } catch (error) {
      console.error('Error uploading file:', error);
      setMessage('Error uploading file');
    }
  };

  return (
    <div>
      <h1>Upload Word Document</h1>
      <form onSubmit={handleSubmit}>
        <input type="file" onChange={handleFileChange} />
        <button type="submit">Upload</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default UploadWordDocument;